import React from "react";
import styled from "styled-components";
import { GlassmorphismContainer } from "../styled/shared/Glassmorphism";
import { usePointStore, useTilesetStore } from "../../Store/store";
import { getTileset } from "../../api/ProjectAPI";

const DockerCardContainer = styled(GlassmorphismContainer)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  gap: 10px;

  h3 {
    font-size: 16px;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    color: #cecece;
  }
`;

const DockerCardHeader = styled.header`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
`;

const DockerCardContent = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  button {
    background: transparent;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 0;
    svg {
      color: #66cd7c;
      width: 100%;
      height: 100%;
    }
  }
  .disabled {
    cursor: default;
    svg {
      color: #808080;
    }
  }
`;

export default function DockerCard({ task }) {
  const { fileId, setFileId } = usePointStore();
  const { setTilesetUrl } = useTilesetStore();
  const { setIsTilesetLoaded } = useTilesetStore();

  const onMapRendering = async (fileId) => {
    const response = await getTileset(fileId, "cesium");
    setFileId(fileId); // 버튼 식별용 파일 아이디 지정
    setTilesetUrl(response.baseUrl); // 타일셋 주소 지정
    setIsTilesetLoaded(true);
  };
  return (
    <DockerCardContainer>
      <DockerCardHeader>
        <h3>{task.name}</h3>
        <p>{task.description}</p>
      </DockerCardHeader>
      <DockerCardContent>
        <button
          disabled={fileId === task.fileId}
          className={fileId === task.fileId ? "disabled" : ""}
          onClick={() => onMapRendering(task.fileId)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-play-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z" />
          </svg>
        </button>
      </DockerCardContent>
    </DockerCardContainer>
  );
}
